'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002448 from "./presto.types$-Credential-Name$$anon$48.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002449 from "./presto.types$-Credential-Name$$anon$49.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialName$() {
  this.c4L = null;
  this.c4M = false;
  this.c4J = null;
  this.c4K = false;
  this.c4P = null;
  this.c4Q = false;
  this.c4N = null;
  this.c4O = false;
  this.c4R = null;
  this.c4S = false;
}
export { $c_Lpresto_types$CredentialName$ as $c_Lpresto_types$CredentialName$ };
$p = $c_Lpresto_types$CredentialName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialName$;
/** @constructor */
function $h_Lpresto_types$CredentialName$() {
}
export { $h_Lpresto_types$CredentialName$ as $h_Lpresto_types$CredentialName$ };
$h_Lpresto_types$CredentialName$.prototype = $p;
$p.cs4 = (function() {
  if ((!this.c4M)) {
    this.c4L = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c4M = true;
  }
  return this.c4L;
});
$p.gm = (function() {
  if ((!this.c4K)) {
    this.c4J = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c4K = true;
  }
  return this.c4J;
});
$p.adG = (function() {
  if ((!this.c4Q)) {
    this.c4P = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c4Q = true;
  }
  return this.c4P;
});
$p.adE = (function() {
  if ((!this.c4O)) {
    this.c4N = new $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002448.$c_Lpresto_types$CredentialName$$anon$48(this);
    this.c4O = true;
  }
  return this.c4N;
});
$p.GK = (function() {
  if ((!this.c4S)) {
    this.c4R = new $j_presto$002etypes$0024$002dCredential$002dName$0024$0024anon$002449.$c_Lpresto_types$CredentialName$$anon$49(this);
    this.c4S = true;
  }
  return this.c4R;
});
var $d_Lpresto_types$CredentialName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialName$, "presto.types$CredentialName$", ({
  YW: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialName$ as $d_Lpresto_types$CredentialName$ };
var $n_Lpresto_types$CredentialName$;
function $m_Lpresto_types$CredentialName$() {
  if ((!$n_Lpresto_types$CredentialName$)) {
    $n_Lpresto_types$CredentialName$ = new $c_Lpresto_types$CredentialName$();
  }
  return $n_Lpresto_types$CredentialName$;
}
export { $m_Lpresto_types$CredentialName$ as $m_Lpresto_types$CredentialName$ };
//# sourceMappingURL=presto.types$-Credential-Name$.js.map
